import { Component, OnInit,Inject } from '@angular/core';
import { equipmentListVM } from '../../component-forecast/component-forecast.model';
import { ComponentForecastService } from '../../component-forecast/component-forecast.service';
import { CustomerService } from '../../GET_NEW_UI/services/customer.service';
import { CustomerContactService } from '../add-new-user-cl/customer-contact.service';
//import { CrsfJobSiteService } from '../crsf-job-site.service';
import { crsfNewVM, CustomerUserContacts, EqLevelData, EqLevelDataforCustomerContact, EquipmentTabVM } from '../Models/customer-contact.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-add-new-user-el',
  templateUrl: './add-new-user-el.component.html',
  styleUrls: ['./add-new-user-el.component.css']
  
})

export class AddNewUserElComponent implements OnInit {
  
  array1:any = [];
  array2:any = [];

  
  
  selectedOptions1:any []= [];
  selectedOptions2:any []= [];
  
  jobsitebyCustomerID:crsfNewVM[]
  JobsiteList:crsfNewVM[];
  
  
  UserVList:any;
  selectedUserId:number;
  customerId:number;
  EquipList:EquipmentTabVM[];
  EquipListByJobsiteID:EquipmentTabVM[];
  selectedSiteId:string;
  selectedEQId:string='';
  equipmnentList: equipmentListVM[]


  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private  _dialog:MatDialog,
    public dialogRef:MatDialogRef<AddNewUserElComponent>,
   // private _JobsiteService:CrsfJobSiteService,
    private _userVService:CustomerContactService,
    private _contactService:CustomerContactService,
    private _customerService:CustomerService,
    public _fleetService: ComponentForecastService,
  ) { }

  ngOnInit() {
    this.GetJobSiteDetails();
    this.GetuserDetails();
    this.customerId=this.data.customerId;
    //this.AddNewUsertoJobsite();
   // this.getEquipmentInfo();
    //console.log("this.selectedCustomer",this.selectedSiteId)
    console.log("this.selectedEQID",this.selectedEQId)
    //this. PostELData();
    
    
  }
  
  
  DialogClose(){
    this.dialogRef.close(false)

  }
  AddNew(){
    this.dialogRef.close(true)
  }

  GetJobSiteDetails(){
    
    this._customerService.getCrsfInfo_().subscribe(res=>{
      this.JobsiteList = res
  
      console.log("this.customerauto",this.JobsiteList);
      this.jobsitebyCustomerID= this.JobsiteList.filter(x=>x.customer_auto == this.customerId);
      console.log("this.jobsitebyCustomerID",this.jobsitebyCustomerID);
      

  });
  }

  // GetJobSiteDetails(){

  // //   this._JobsiteService.GetJobSiteDetails().subscribe(res=>{
  // //     this.JobsiteList = res;
  
  // //     console.log("this.selectedUserId",this.JobsiteList);
  // // })
  // }

  
  GetuserDetails(){
    this._customerService.GetuserDetails_(this.customerId).subscribe(res=>{
      this.array1 = res;
  
      console.log("this.userlist",this.UserVList);
  })
}

  typesOfShoes: string[] = ['Boots', 'Clogs', 'Loafers', 'Moccasins', 'Sneakers','Boots', 'Clogs', 'Loafers', 'Moccasins', 'Sneakers','Boots', 'Clogs', 'Loafers', 'Moccasins', 'Sneakers'];
  //equipment dialog data
  //PostELData(){
   
  //}

  jobsiteChanged(event:any) {
    let value = event.value;
    this.selectedSiteId = event.value;
    this._fleetService.getEquipmentList(value).subscribe(result => {
        this.equipmnentList = result
        console.log("EquipmentId",this.equipmnentList)
      })
    }

    // equipmentChanged(event:any) {
    //   let value = event.value;
    //   this.selectedSiteId = event.value;
    
    //     this._fleetService.getEquipmentList(value).subscribe(result => {
    //       this.equipmnentList = result
    //     })
    //   }
    

  //AddNewUsertoJobsite
  AddNewEL()
  {
    let useridarray:any[]=[];
    
    if(this.array2.length>0)
    {
      this.array2.map(item =>{if(item.userID){
        useridarray.push(item.userID)
      }}
      )
  
    }
    console.log("array2", this.array2)
    console.log("add", this.selectedEQId)
      let params = new  EqLevelDataforCustomerContact();
      params.customer_auto=this.customerId;
      params.user_auto=useridarray;
      params.EvalA=true;
      params.EvalB=true;
      params.EvalC=true;
      params.EvalX=true;
      params.crsf_auto=Number(this.selectedSiteId);
      params.equipmentid_auto=Number(this.selectedEQId)!;
      params.Type="EQ"
      
  
      
  
      console.log("this.params",params);
      this._customerService.AddEquipmentdata(params).subscribe(res=>{
        console.log("result",res);
        if(res=true)
        {
          this.DialogClose();
        }
      })
      console.log("this.selectedUserId",this.customerId);
      
  }
  
  public groupA: { [key: string]: Object }[] = [
    { "Name": "Australia", "Code": "AU" },
    { "Name": "Bermuda", "Code": "BM" },
    { "Name": "Canada", "Code": "CA" },
    { "Name": "Cameroon", "Code": "CM" },
    { "Name": "Denmark", "Code": "DK" },
    { "Name": "France", "Code": "FR" },
    { "Name": "Finland", "Code": "FI" },
    { "Name": "Germany", "Code": "DE" },
    { "Name": "Hong Kong", "Code": "HK" }
];

public groupB: { [key: string]: Object }[] = [
    { "Name": "India", "Code": "IN" },
    { "Name": "Italy", "Code": "IT" },
    { "Name": "Japan", "Code": "JP" },
    { "Name": "Mexico", "Code": "MX" },
    { "Name": "Norway", "Code": "NO" },
    { "Name": "Poland", "Code": "PL" },
    { "Name": "Switzerland", "Code": "CH" },
    { "Name": "United Kingdom", "Code": "GB" },
    { "Name": "United States", "Code": "US" }
];
public setfield = { text: "Name" }
//public toolbar = { items: ['moveTo', 'moveFrom'] }
/*
AddNewUsertoJobsite(){
 
  console.log("addEquipment", this.array2)
      let params = new  CustomerUserContacts();
      params.customer_auto=this.customerId;
      params.user_auto=this.selectedUserId;
      params.equipmentid_auto=0;
      params.EvalA=true;
      params.EvalB=true;
      params.EvalC=true;
      params.EvalX=true;
      params.eq_undercarriage=true;
      params.Type="CUST";
      
  
  
      this._contactService.AddNewUsertoJobsite(params).subscribe(res=>{
        console.log("result",res);
      })
      console.log("this.selectedUserId",this.selectedUserId);
    }
    */


    // getEquipmentInfo(){

      
    //   this._customerService.getEquipmentInfo().subscribe(res=>{
    //     this.EquipList = res;
    //     this.EquipListByJobsiteID=this.EquipList//.filter(x=> x.crsf_auto==Number(this.selectedSiteId))
    
    //     console.log("this.EquipList",this.EquipList);
    // })
    // }

  
    AddItem() {
      if (this.selectedOptions1.length > 0) {
        this.selectedOptions1.map(x => {
          if (this.array2.length > 0) {
            let checkhasexisitng = this.array2.find(z => z.id == x.id);
            if (!checkhasexisitng) {
              this.array2.push(x);
            }
          } else {
            this.array2.push(x);
          }
        });
      }
    }


    RemoveItem() {
      if (this.selectedOptions2.length > 0) {
        this.selectedOptions2.map(x => {
          this.array2 = this.array2.filter(z => z.id != x.id);
          this.selectedOptions2 = [];
        });
      }
    }
}
